export const constants = {
  environment: {
    DEV: 'development',
    PRODUCTION: 'production',
    QA: 'qa',
    UNIT_TEST: 'test'
  }
};
